(function (upp) {
    'use strict';

    upp.service('utils', ['$rootScope', 'translator',
        function ($rootScope, translator) {

            /**
             * Returns a string sanitized (without strange characters and blank spaces)
             *
             * @method sanitize
             * @param {String} text Text to sanitize
             * @return {String} Returns the sanitized text
             */
            var sanitize = function (text) {
                if (text) {
                    var characters = [' ', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '+', '=', '_', '{', '}', '[', ']', '|', '/', '<', '>', ',', '.', '?', '--'],
                        i = 0,
                        length = characters.length,
                        _char;

                    for (; i < length; i++) {
                        _char = String(characters[i]);
                        text = text.replace(new RegExp("\\" + _char, "g"), '-');
                    }
                    text = text.toLowerCase();
                } else {
                    text = "";
                }

                return text;
            };

            /**
             * Returns the 'id' of 'params' if it's has the following structure: {whatever}-{id}
             *
             * @method getIdFromParams
             * @param {String} params
             * @param {String} token
             * @return {String} Returns id
             */
            var idFromParams = function (params, token) {
                var id = "";
                if (params) {
                    token = token || "-";
                    if (params.indexOf(token) > -1) {
                        params = params.split(token);
                        id = params[params.length - 1];
                    }
                }

                return id;
            };

            /**
             * Transform an array removing duplicates items
             *
             * @method getUnique
             * @param {Array} arr Input array with duplicates
             * @return {Array} Returns Output array without duplicates
             */
            var getUnique = function (arr) {
                var u = {},
                    retArray = [],
                    length,
                    elto,
                    i = 0;

                if (arr instanceof Array) {
                    length = arr.length;
                    for (; i < length; ++i) {
                        elto = arr[i];
                        if (u.hasOwnProperty(elto)) {
                            continue;
                        }
                        retArray.push(elto);
                        u[elto] = 1;
                    }
                } else {
                    throw new Error("Input is not an array");
                }

                return retArray;
            };

            //TODO: shouldn't be here -> NavBarFactory / TemplateFactory
            /**
             * Returns the html needed to create a navbar
             *
             * @method navBarTemplate
             * @param {String} actualTab Active tab in the navbar
             * @param {Array} tabs Array of tabs. Each tab is an object that should have the following attributes: tab, link, label
             * @return {String} Returns 'navbar' html
             */
            var navBarTemplate = function () {
                var getLiHtml = function (actualTab, tabs) {
                    var html = '',
                        x = 0,
                        it,
                        length = tabs.length;

                    for (; x < length; x++) {
                        it = tabs[x];

                        if (it.tab && it.link && it.label) {
                            html += '<li class="nav-opt ';
                            if (it.tab === actualTab) {
                                html += 'active';
                            }

                            html += '"><a class="nav-opt-link" href="#!' + it.link + '">{{\'' + it.label + '\' | i18n}}</a></li>';
                        } else {
                            throw new Error("without required info for this tab");
                        }
                    }

                    return html;
                };

                return function (actualTab, tabs) {
                    var html = "";
                    if (actualTab) {
                        html = '	<ul class="nav nav-pills nav-tabs-responsive">';
                        html += getLiHtml(actualTab, tabs);
                        html += '	</ul>';
                    } else {

                        throw new Error("actual tab not found");
                    }
                    return html;
                }
            }();

            //TODO: shouldn't be here -> BreadcrumbFactory / TemplateFactory
            /**
             * Returns the html needed to create a breadcrumb with several steps, an actual one, and a next button
             *
             * @method breadCrumbTemplate
             * @param {String} actualStep Active step in the breadcrumb
             * @param {Array} steps Array of steps. Each step is an object that should have the following attributes: step, label, next step info
             * @param {String} nextDisabled Condition that disables the next button
             * @return {String} Returns 'breadCrumb' html
             */
            var breadCrumbTemplate = function () {
                var getLiHtml = function (prev, me, next) {
                    var html = '',
                        x,
                        divider = '',
                        it,
                        length;

                    //Previous options in the breadcrumb
                    if (prev) {
                        x = 0;
                        length = prev.length;

                        for (; x < length; x++) {
                            it = prev[x];

                            if (it.link && it.label) {
                                html += '       <li class="disabled"><a href="#!' + it.link + '">{{"' + it.label + '" | i18n}}</a>' + divider + '</li>';
                            } else {
                                throw new Error("without required info to prev step");
                            }
                        }
                    }

                    //Actual option in the breadcrumb
                    if (me.label && me.actualCount && me.totalCount) {
                        html += '       <li class="actual" data-actual="' + me.actualCount + '" data-total="' + me.totalCount + '">{{"' + me.label + '" | i18n}}' + (next ? divider : "") + '</li>';
                    } else {
                        throw new Error("without required info to actual step");
                    }

                    //Following options in the breadcrumb
                    if (next) {
                        x = 0;
                        length = next.length;
                        for (; x < length; x++) {
                            it = next[x];

                            if (it.label) {
                                html += '		<li class="disabled">{{"' + it.label + '" | i18n}}';
                            } else {
                                throw new Error("without required info to next step");
                            }

                            if ((x + 1) != length) {
                                html += divider;
                            }

                            html += '		</li>';
                        }
                    }

                    return html;
                };

                return function (actualStep, steps, nextDisabled) {
                    var x = 0,
                        y,
                        lenght = steps.length,
                        it,
                        actual,
                        next,
                        prevs = [],
                        nexts = [],
                        html = '';

                    //Compose array's of previous / followings steps.
                    for (; x < lenght; x++) {
                        it = steps[x];
                        if (actualStep == it.step) {
                            actual = it;
                            for (y = x + 1; y < lenght; y++) {
                                nexts.push(steps[y]);
                            }
                            break;
                        } else {
                            prevs.push(it);
                        }
                    }

                    if (actual) {
                        actual.actualCount = x + 1;
                        actual.totalCount = lenght;

                        html = '<div class="breadcrumb">';
                        html += '<ul>' + getLiHtml(prevs, actual, nexts) + '</ul>';

                        if (next = actual.next) {
                            if ((next.link || next.func) && next.label && next.icon) {
                                html += '<button type="button" class="btn btn-success btn-submit next" ';
                                if (nextDisabled) {
                                    html += 'ng-disabled="' + nextDisabled + '" ';
                                }

                                if (next.link) {
                                    html += 'onclick="location.href=\'#!' + next.link + '\'"';
                                } else if (next.func) {
                                    html += 'ng-click="' + next.func + '"';
                                }

                                html += '>{{"' + next.label + '" | i18n}}<i class="' + next.icon + '"></i></button>';
                            } else {
                                throw new Error("'next step' info required");
                            }
                        }

                        html += '</div>';
                    } else {
                        throw new Error("actual step not found");
                    }

                    return html;
                }
            }();

            //TODO: shouldn't be here
            /**
             * Broadcast an event
             *
             * @method broadcast
             * @param {String} event name of the event to be broadcasted
             * @param {Object} params optional
             */
            var broadcast = function (event, params) {
                if (event) {
                    event = 'event:' + event;
                    $rootScope.$broadcast(event, params);
                }
            };

            /**
             * Translate http error codes if found, if not, returns 'HTTP.ERROR.DEFAULT' as default
             *
             * @method i18nHttpErrorCode
             * @param {String} code Error code
             * @return {String} Translated string
             */
            var i18nHttpErrorCode = function (code) {
                var keySeed = 'HTTP.ERROR.',
                    key,
                    msg;

                if (!code) {
                    code = 'DEFAULT';
                }

                key = keySeed + code;
                msg = translator.i18n(key);
                if (msg === key) {
                    msg = translator.i18n(keySeed + 'DEFAULT');
                }

                return msg;
            };

            return {
                sanitize : sanitize,
                idFromParams : idFromParams,
                getUnique : getUnique,
                breadCrumbTemplate : breadCrumbTemplate,
                navBarTemplate : navBarTemplate,
                broadcast : broadcast,
                i18nHttpErrorCode : i18nHttpErrorCode
            };
        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/common/services/utils-service.js